import { NgModule } from '@angular/core';
import { AccessValuePipe } from './access-value.pipe';


@NgModule({
    imports: [],
    exports: [AccessValuePipe],
    declarations: [AccessValuePipe],
    providers: [],
})
export class AccessValuePipeModule { }
